import { render } from "./HomeContact.html?vue&type=template&id=20a3098e&scoped=true&ts=true&external"
import script from "./HomeContact.ts?vue&type=script&lang=ts&external"
export * from "./HomeContact.ts?vue&type=script&lang=ts&external"

import "./HomeContact.scss?vue&type=style&index=0&id=20a3098e&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a3098e"]])

export default __exports__